import React, { FC } from "react";
import {
  AppNavigationLayout,
  useNavigationType,
} from "shared-ts-ui-app-layout";
import { useTranslation } from "react-i18next";
import RoofingRoundedIcon from "@mui/icons-material/RoofingRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import { ActionGroup, RouteItem, Spacer } from "shared-ts-ui-action";
import { Outlet } from "@tanstack/react-router";
import { useChangeThemeAction } from "shared-ts-ui-app-theme-provider";
import { AirmontLogoImg } from "shared-ts-ui-airmont";
import { Typography, useTheme } from "@mui/material";
import { Component } from "shared-ts-ui-navigation";
import { useNavigation } from "shared-ts-tanstack-react-router-navigation";

export const RootComponent: FC = () => {
  const { t } = useTranslation("firefly-my-chimney-users-ts-translations");
  const theme = useTheme();
  const changeThemeAction = useChangeThemeAction();
  const { navigationType } = useNavigationType();
  const { navigationItems, handleSelected } = useNavigation(
    [
      {
        type: "Component",
        render: (navigationType) => (
          <AirmontLogoImg
            size={navigationType === "drawer" ? "standard" : "small"}
            sx={{ m: 1 }}
          />
        ),
      } as Component,
      {
        type: "Component",
        render: (navigationType) => (
          <Typography
            variant={"button"}
            color={"primary"}
            align={"center"}
            sx={{
              paddingTop: theme.spacing(1),
              textTransform: "unset",
              fontSize: navigationType === "drawer" ? "2em" : undefined,
            }}
          >
            {t("My Chimney Users")}
          </Typography>
        ),
      } as Component,
      {
        type: "RouteItem",
        selectable: true,
        name: t("Users"),
        route: "/users",
        icon: <PeopleAltRoundedIcon />,
        selected: false,
      } as RouteItem,
      {
        type: "RouteItem",
        selectable: true,
        name: t("Addresses"),
        route: "/addresses",
        icon: <RoofingRoundedIcon />,
        selected: false,
      } as RouteItem,
      { type: "Spacer" } as Spacer,
      {
        type: "ActionGroup",
        items: [
          {
            type: "RouteItem",
            selectable: true,
            name: t("User"),
            route: "/user",
            icon: <PersonRoundedIcon />,
            selected: false,
          } as RouteItem,
          changeThemeAction,
          {
            type: "RouteItem",
            selectable: true,
            name: t("About"),
            route: "/about",
            icon: <InfoRoundedIcon />,
            selected: false,
          } as RouteItem,
        ],
      } as ActionGroup,
    ],
    [changeThemeAction, t],
    navigationType
  );

  return (
    <AppNavigationLayout
      variant={"flat"}
      navigationItems={navigationItems}
      main={<Outlet />}
      onNavigationItemSelected={handleSelected}
    />
  );
};
